import { Box, Card, CardContent, Typography } from "@mui/material";
import { Divider } from "../../widgets";
import styles from "./S4_AppSection.module.scss";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";

const WowServices = (props: any) => {
  const { appSection } = props;

  return (
    appSection && (
      <Box sx={{ backgroundColor: "var(--white)" }}>
        <Box
          sx={{
            width: "90%",
            margin: "0px auto",
            paddingBottom: "50px",
            marginBottom: "40px",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontFamily: " var(--font_family_Bold)",
              color: "var(--text_color_12)",
              fontSize: "40px",
              fontWeight: "var(--font_weight_4)",
              textTransform: "capitalize",
            }}
          >
            {appSection?.appSectionHeading}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            flexDirection: { md: "row", xs: "column" },
            padding: "50px 20px",
            background: "var(--white)",
            paddingTop: { xs: "30px", sm: 0 },
          }}
        >
          {appSection?.appSectionData.map((item: any, index: any) => {
            return (
              <Card
                sx={{
                  maxWidth: { md: 278 },
                  width: "100%",
                  padding: { xs: "10px 20px", sm: "40px 20px" },
                  boxSizing: "border-box",
                  boxShadow: {
                    xs: "none",
                    md: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  },
                }}
                key={index}
              >
                <CardContent
                  sx={{
                    padding: "0 !important",
                    display: { xs: "flex" },
                    flexDirection: { xs: "row", md: "column" },
                  }}
                >
                  <Box
                    component="img"
                    alt={item?.image?.data?.attributes?.alternativeText}
                    src={item?.image?.data?.attributes?.url || ""}
                    height="40px"
                    sx={{
                      width: "58px",
                      paddingLeft: { xs: index === 0 ? "17px" : 0, sm: 0 },
                    }}
                  ></Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontFamily: " var(--font_family_Bold)",
                        marginTop: { md: 2 },
                        color: "var(--text_color_12)",
                        fontWeight: "var(--font_weight_4)",
                        marginLeft: { xs: 2, md: 0 },
                      }}
                      gutterBottom
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="h5"
                      component="div"
                      sx={{
                        fontSize: "16px",
                        marginTop: { md: 2 },
                        fontFamily: " var(--font_family)",
                        color: "var(--text_color_12)",
                        marginLeft: { xs: 2, md: 0 },
                        lineHeight: "28px",
                        width: "100%",
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>
      </Box>
    )
  );
};

export default WowServices;
